// src/services/Judge0Api.js
import axios from "axios";

const apiUrl = "https://judge0-ce.p.rapidapi.com/submissions";
const apiKey = "8fab081e91msh943e86636ad0bd9p147730jsnfc323008c4d6"; // 🔑 Replace with your actual RapidAPI key

// Language ID map for Judge0
const languageMap = {
    java: 62,
    cpp: 54,
    python: 71,
    javascript: 63
};

export const executeCode = async (language, code) => {
    const languageId = languageMap[language];

    if (!languageId) return "Unsupported language";

    try {
        const submissionResponse = await axios.post(
            apiUrl,
            {
                language_id: languageId,
                source_code: code,
                stdin: ""
            },
            {
                headers: {
                    "X-RapidAPI-Key": apiKey,
                    "X-RapidAPI-Host": "judge0-ce.p.rapidapi.com",
                    "Content-Type": "application/json"
                },
                params: {
                    base64_encoded: "false",
                    wait: "true"
                }
            }
        );

        const result = submissionResponse.data;

        if (result.stderr) return result.stderr;
        if (result.compile_output) return result.compile_output;
        return result.stdout || "No output";
    } catch (error) {
        console.error("Error executing code:", error?.response?.data || error.message);
        return "Error executing code";
    }
};
